export default __webpack_public_path__ + "static/media/NHLFantasyChallengeMobileCardBG@2x.da225176.png";